import React from 'react';
import { Helmet } from 'react-helmet-async';

interface VideoData {
  name: string;
  description: string;
  thumbnailUrl: string;
  uploadDate: string;
  duration: string;
  embedUrl: string;
  contentUrl?: string;
  publisher?: {
    name: string;
    logo?: string;
  };
}

interface VideoStructuredDataProps {
  video: VideoData;
}

const VideoStructuredData: React.FC<VideoStructuredDataProps> = ({ video }) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": video.name,
    "description": video.description,
    "thumbnailUrl": video.thumbnailUrl,
    "uploadDate": video.uploadDate,
    "duration": video.duration,
    "embedUrl": video.embedUrl,
    "contentUrl": video.contentUrl,
    "publisher": video.publisher ? {
      "@type": "Organization",
      "name": video.publisher.name,
      "logo": video.publisher.logo ? {
        "@type": "ImageObject",
        "url": video.publisher.logo
      } : undefined
    } : {
      "@type": "Organization",
      "name": "Cats About Town Tours",
      "url": "https://catsabouttowntours.com"
    },
    "potentialAction": {
      "@type": "SeekToAction",
      "target": video.embedUrl,
      "startOffset-input": "required name=t"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default VideoStructuredData;